<template>
	<div class="loading__wrap">
    <div class="loading" v-show="flag">
      <div class="loading__inner">
        <i class="loading__icon"></i>
      </div>
    </div>
   </div>
</template>

<script>
  import loader from './loader';
  export default loader;
</script>
